var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsletter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.240234,
    y: 0.355957,
    width: 41.6947,
    height: 41.6947,
    rx: 11.8004,
    fill: "#FFDAD4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4247 15.3032H14.7506C13.9056 15.3032 13.2207 15.9882 13.2207 16.8331C13.2207 17.3509 13.4826 17.8336 13.9168 18.1158L19.7157 21.885C20.2123 22.2078 20.4606 22.3692 20.7281 22.432C20.9646 22.4875 21.2107 22.4875 21.4472 22.432C21.7147 22.3692 21.963 22.2078 22.4596 21.885L28.2585 18.1158C28.6926 17.8336 28.9546 17.3509 28.9546 16.8331C28.9546 15.9882 28.2696 15.3032 27.4247 15.3032Z",
    stroke: "#FF4A4A",
    strokeWidth: 1.41605
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5604 18.0566V24.5862C28.5604 25.4674 28.5604 25.908 28.389 26.2445C28.2381 26.5406 27.9974 26.7813 27.7014 26.9321C27.3648 27.1036 26.9242 27.1036 26.043 27.1036H16.1307C15.2495 27.1036 14.8089 27.1036 14.4724 26.9321C14.1763 26.7813 13.9356 26.5406 13.7848 26.2445C13.6133 25.908 13.6133 25.4674 13.6133 24.5862V18.0566",
    stroke: "#FF4A4A",
    strokeWidth: 1.41605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/newsletter.2a12ba6c204905e988d71f95b9b6df06.svg";
export { ForwardRef as ReactComponent };